module.exports = __webpack_public_path__ + "static/img/pcq.51fa643f.svg";